import { Link } from "react-router-dom";

export default function Programs({ section, programs = [] }) {
  if (!section || section.is_enabled === 0 || programs.length === 0) return null;

  return (
    <section className="programs section" id="courses" aria-label="Programs offered">
      <div className="section__inner">
        <div className="section__header">
          {section.badge && <span className="section__tag">{section.badge}</span>}
          <h2 className="section__title">{section.title}</h2>
          {section.subtitle && <p className="section__subtitle">{section.subtitle}</p>}
        </div>

        <div className="programs__grid">
          {programs.map((program) => (
            <div key={program.name} className="program-card-full" style={{ "--card-color": program.color }}>
              <div className="program-card-full__image-wrap">
                <img
                  src={program.image}
                  alt={program.name}
                  className="program-card-full__image"
                  loading="lazy"
                />
                <div className="program-card-full__image-overlay" />
                <span className="program-card-full__badge">{program.duration}</span>
              </div>

              <div className="program-card-full__body">
                <h3 className="program-card-full__title">{program.name}</h3>

                <div className="program-card-full__meta">
                  <span className="program-card-full__meta-item">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    Intake: {program.intake}
                  </span>
                  <span className="program-card-full__meta-item">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
                    {program.modules}
                  </span>
                </div>

                <p className="program-card-full__desc">{program.description}</p>

                <div className="program-card-full__section-label">Skills You Will Learn</div>
                <ul className="program-card-full__skills" aria-label="Skills covered">
                  {program.skills.map((skill) => (
                    <li key={skill} className="program-card-full__skill">{skill}</li>
                  ))}
                </ul>

                <div className="program-card-full__section-label">Career Paths</div>
                <ul className="program-card-full__careers" aria-label="Career paths">
                  {program.careers.map((career) => (
                    <li key={career} className="program-card-full__career-item">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
                      {career}
                    </li>
                  ))}
                </ul>

                <Link to="/admissions" className="program-card-full__cta">
                  Apply for This Program
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
